// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__2gK-s","modal__remainbutton":"deleteModal_modal__remainbutton__3Rl-p","modal__deletebutton":"deleteModal_modal__deletebutton__m_C-E"};